import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

/**
 * Leva a janela para o topo a cada navegação.
 *
 * O react-router não restaura scroll sozinho: ao clicar num item do fim da
 * barra lateral, a página nova abria já rolada na mesma posição da anterior.
 * A dependência em `key` cobre o clique no item já ativo, que gera um PUSH
 * novo sem mudar o pathname.
 */
export default function ScrollToTop() {
    const {pathname, key} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname, key]);

    return null;
}
